// extracted by mini-css-extract-plugin
export default {"arrow":"languageselect_arrow__DE-Gp","but":"languageselect_but__Wqmqd"};